export default {
  // Reset Password Form
  setNewPassword: 'Establecer Nueva Contraseña',
  newPassword: 'Nueva contraseña',
  confirmNewPassword: 'Confirmar nueva contraseña',
  forgotPassword: '¿Olvidaste tu contraseña?',
  passwordRequirementsTitle: 'Requisitos de la Nueva Contraseña',
  passwordRequirementsIntro: 'La nueva contraseña debe:',
  passwordReqLength: 'Tener al menos 12 caracteres',
  passwordReqNumber: 'Incluir un número',
  passwordReqLowercase: 'Incluir una letra minúscula',
  passwordReqUppercase: 'Incluir una letra mayúscula',
  passwordReqSpecial: 'Incluir un carácter especial',
  passwordReqSpecialChars: '(#, ?, !, @, $, %, ^, *, -)',
  checkEmailForReset: 'Revisa tu correo electrónico para las instrucciones de restablecimiento de contraseña.',
  ok: 'OK',
  resetPassword: 'Restablecer contraseña',
  enterYourEmail: 'Ingresa tu correo electrónico',
  cancel: 'Cancelar',
  sendResetEmail: 'Enviar correo de restablecimiento',

  // Password Dialog (logged in)
  setANewPassword: 'Establecer una nueva contraseña',
  currentPassword: 'Contraseña actual',
  repeatNewPassword: 'Repetir nueva contraseña',
  proceed: 'Continuar',
  forgotCurrentPassword: '¿Olvidaste tu contraseña actual? (te enviaremos un correo)',
  passwordResetEmailSent: 'Recibirás un correo electrónico con instrucciones para restablecer tu contraseña en los próximos minutos.',

  // Terms & Conditions
  termsAndConditions: 'Términos y Condiciones',
  termsTitle: 'Términos y Condiciones de Uso',
  termsSection1Title: '1. Definiciones',
  termsSection1User: '"Usuario" significa un empleado de una empresa que ha celebrado un contrato con NoiseGrasp para acceder a los Servicios.',
  termsSection1Services: '"Servicios" significa la plataforma de Marketing Mix Modeling, herramientas relacionadas, software y todas las funcionalidades asociadas proporcionadas por NoiseGrasp.',
  termsSection2Title: '2. Aceptación de los Términos',
  termsSection2Content: 'Al acceder y utilizar los Servicios, el Usuario acepta y acuerda quedar obligado por los términos y disposiciones de este acuerdo. El acceso a los Servicios se proporciona bajo el contrato entre la empresa del Usuario y NoiseGrasp.',
  termsSection3Title: '3. Restricciones',
  termsSection3Intro: 'El Usuario no deberá (y no autorizará a ningún tercero a):',
  termsSection3Item1: 'modificar, traducir, realizar ingeniería inversa, descompilar, desensamblar o crear trabajos derivados basados en los Servicios, excepto en la medida en que la aplicación de la restricción anterior esté prohibida por la ley aplicable;',
  termsSection3Item2: 'eludir cualquier límite u otras restricciones de tiempo, uso o funcionalidad incorporadas en los Servicios;',
  termsSection3Item3: 'eliminar cualquier aviso de propiedad, etiquetas o marcas de los Servicios.',
  termsSection4Title: '4. Responsabilidades de Seguridad del Usuario',
  termsSection4Intro: 'El Usuario es responsable de mantener la seguridad y confidencialidad de sus credenciales de cuenta e información de acceso. El Usuario debe:',
  termsSection4Item1: 'mantener todas las credenciales de inicio de sesión seguras y confidenciales;',
  termsSection4Item2: 'no compartir el acceso a la cuenta con personas no autorizadas;',
  termsSection4Item3: 'notificar inmediatamente a NoiseGrasp sobre cualquier sospecha de violación de seguridad o acceso no autorizado a su cuenta;',
  termsSection4Item4: 'ser responsable de todas las actividades que ocurran bajo su cuenta.',
  termsSection5Title: '5. Propiedad y Derechos de Propiedad',
  termsSection5Content1: 'NoiseGrasp posee y conservará todos los derechos, títulos e intereses (incluyendo sin limitación todos los derechos de patente, derechos de autor, derechos de marca registrada, derechos de secreto comercial y otros derechos de propiedad intelectual), sobre los Servicios. El Usuario acepta que solo NoiseGrasp tendrá el derecho de mantener, mejorar o modificar de otra manera los Servicios.',
  termsSection5Content2: 'Si el Usuario proporciona a NoiseGrasp informes de defectos en los Servicios o propone o sugiere cualquier cambio o modificación (colectivamente "Retroalimentación"), NoiseGrasp tendrá el derecho de usar y explotar dicha Retroalimentación incluyendo, sin limitación, la incorporación de dicha Retroalimentación en los productos y/o servicios de software de NoiseGrasp, incluyendo, sin limitación, los Servicios, sin ninguna obligación hacia el Usuario. NoiseGrasp se reserva todos los derechos y no otorga al Usuario ninguna licencia de ningún tipo, ya sea por implicación, impedimento legal o de otra manera.',
  termsSection6Title: '6. Uso Comercial',
  termsSection6Content: 'Estos Servicios se proporcionan para uso comercial por empleados de empresas que han contratado con NoiseGrasp. Estos Términos y Condiciones son parte de un contrato más amplio firmado entre las empresas y NoiseGrasp.',
  termsSection7Title: '7. Privacidad de Datos',
  termsSection7Intro: 'NoiseGrasp está comprometido con la protección de la privacidad del Usuario. Nuestras prácticas de recopilación de datos son mínimas y se limitan a:',
  termsSection7Item1: 'Direcciones de correo electrónico y nombres de usuario, que sirven solo como identificación;',
  termsSection7Item2: 'cookies esenciales necesarias para el funcionamiento adecuado de los Servicios;',
  termsSection7Item3: 'sin seguimiento de información personal ni monitoreo de comportamiento;',
  termsSection7Item4: 'sin uso de cookies de seguimiento ni recopilación de datos personales más allá de lo necesario para la operación del sistema.',
  termsSection7Content: 'Todos los datos cargados y procesados a través de los Servicios se manejan de acuerdo con las regulaciones de protección de datos aplicables.',
  termsSection8Title: '8. Limitaciones',
  termsSection8Content1: 'NoiseGrasp se compromete a proporcionar servicios con el debido cuidado, diligencia y adherencia a las mejores prácticas y estándares de la industria. Sin embargo, se establece explícitamente que los modelos y entregables resultantes del análisis de datos proporcionados por el Usuario y/o su empresa se derivan de estimaciones y la aplicación de modelos matemáticos complejos. Las conclusiones y resultados obtenidos de estos modelos no están garantizados.',
  termsSection8Content2: 'Además, NoiseGrasp afirma que todos los modelos matemáticos proporcionados a sus clientes son estimaciones basadas en datos y algoritmos matemáticos. No se hacen garantías ni garantías, ya sean expresas o implícitas, con respecto a la idoneidad de estos modelos para lograr cualquier resultado específico. NoiseGrasp renuncia a cualquier responsabilidad por la precisión o confiabilidad de los resultados obtenidos mediante la utilización de sus modelos matemáticos. El Usuario reconoce que cualquier confianza en tales resultados es bajo su propio riesgo.',
  termsSection8Content3: 'A su vez, el Usuario reconoce que el uso de modelos matemáticos inherentemente implica incertidumbres y variaciones potenciales en los resultados. Además, el Usuario acepta utilizar los modelos bajo su propio riesgo, entendiendo que NoiseGrasp no será responsable de ninguna consecuencia que surja de dicho uso.',
  termsSection9Title: '9. Modificaciones',
  termsSection9Content: 'Al usar los Servicios, el Usuario acepta estar obligado por estos Términos y Condiciones de Uso. Si los Términos y Condiciones cambian en el futuro, este aviso se actualizará en consecuencia.',
  termsLastUpdated: 'Última actualización: 15/07/2025',
  acceptTerms: 'Aceptar Términos y Condiciones',
  close: 'Cerrar',

  // What's New Dialog
  whatsNew: 'Novedades',
  posted: 'Publicado {time}',
  previous: 'Anterior',
  next: 'Siguiente',
  ofCount: '({current} de {total})',

  // Model Selection Dialog
  modelSelection: 'Selección de Modelo',
  allCountries: 'Todos los países',
  countriesSelected: '{count} de {total} países seleccionados',
  filterByCountry: 'Filtrar por País',
  searchCountries: 'Buscar países',
  selectAll: 'Seleccionar Todo',
  selectAllVisible: 'Seleccionar Todos los Visibles ({count})',
  allBrands: 'Todas las marcas',
  brandsSelected: '{count} de {total} marcas seleccionadas',
  filterByBrand: 'Filtrar por Marca',
  searchBrands: 'Buscar marcas',
  allClients: 'Todos los clientes',
  clientsSelected: '{count} de {total} clientes seleccionados',
  filterByClient: 'Filtrar por Cliente',
  searchClients: 'Buscar clientes',
  allCategories: 'Todas las categorías',
  categoriesSelected: '{count} de {total} categorías seleccionadas',
  filterByCategory: 'Filtrar por Categoría',
  searchCategories: 'Buscar categorías',
  allSubcategories: 'Todas las subcategorías',
  subcategoriesSelected: '{count} de {total} subcategorías seleccionadas',
  filterBySubcategory: 'Filtrar por Subcategoría',
  searchSubcategories: 'Buscar subcategorías',
  search: 'Buscar',
  adHocModels: 'MODELOS AD-HOC',
  customModels: 'MODELOS PERSONALIZADOS',
  select: 'Seleccionar',
  deployed: 'Desplegado',
  notAvailable: 'N/D',

  // Table Headers
  headerModelName: 'Nombre del Modelo',
  headerBrand: 'Marca',
  headerCountry: 'País',
  current: 'actual',
  versionDeployed: 'Desplegada el {date}',
  headerClient: 'Cliente',
  headerCategory: 'Categoría',
  headerSubcategory: 'Subcategoría',
  headerReference: 'Referencia',
  headerDateCreated: 'Fecha de Creación',
  headerDateModified: 'Fecha de Modificación',
  headerCreatedBy: 'Creado por',

  // Navigation Menu
  currentModel: 'Modelo Actual',
  home: 'Inicio',
  modelSetup: 'Modelo',
  dataUpload: 'Carga de Datos',
  dataCheck: 'Revisión de Datos',
  modelingProcess: 'Progreso',
  modelReport: 'Reporte del Modelo',
  modelOverview: 'Resumen del Modelo',
  whatIfScenario: 'Escenario Hipotético',
  mediaPlanner: 'Planificador',
  planCalculator: 'Calculadora',
  planOptimizer: 'Optimizador',
  budgetSimulator: 'Simulador de Presupuesto',
  documents: 'Documentos',
  admin: 'Admin',
  users: 'Usuarios',
  refModels: 'Modelos Ref.',
  adHocModelsMenu: 'Modelos Ad-Hoc',
  countries: 'Países',
  news: 'Noticias',
  pendingPlans: 'Planes Pendientes',
  aiReviews: 'Revisiones IA',
  errorLogs: 'Registros de Errores',
  automaticModels: 'DIY Models',
  automaticModeler: 'DIY Modeler',
  modelFactory: 'Model Factory',
  modelComposer: 'Model Composer',
  ekrmManager: 'Gestor EKRM',
  userManager: 'Gestor de Usuarios',
  modelManager: 'Gestor de Modelos',
  learningCenter: 'Centro de Aprendizaje',
  stats: 'Estadísticas',
  tools: 'Herramientas',
  logout: 'Cerrar Sesión',

  // Notifications
  clearAllNotifications: 'Borrar todas las notificaciones',
  mediaPlanReady: 'El Plan de Medios está listo',
  modelReportReady: 'El Reporte del Modelo está listo',
  ekrmReady: 'EKRM está listo',
  whatIfScenarioReady: 'El Escenario Hipotético está listo',
  budgetSimulationReady: 'La Simulación de Presupuesto está lista',
  noUnreadNotifications: 'No hay notificaciones sin leer',

  // Login Screen
  login: 'Iniciar Sesión',
  email: 'Correo electrónico',
  password: 'Contraseña',
  loginWithGoogle: 'Iniciar sesión con Google',

  // Loading States
  loading: 'Cargando...',
  authenticatingUser: 'Autenticando usuario...',
  clickToSignIn: 'Haz clic aquí para iniciar sesión con Lion Login',

  // Validation Messages
  required: 'Requerido.',
  wrongPassword: 'Contraseña incorrecta',
  passwordsMustMatch: 'Las contraseñas nuevas deben coincidir',
  passwordMustBeDifferent: 'La nueva contraseña debe ser diferente a la anterior',
  passwordRequirements: 'La contraseña debe tener más de 12 caracteres y debe contener caracteres numéricos, minúsculas, mayúsculas y especiales (#, ?, !, @, $, %, ^, *, -)',

  // Alert Messages
  passwordSetSuccessfully: 'Contraseña establecida exitosamente',
  internalError: 'Error interno, por favor contacta al administrador del sistema. Código de error: ',

  // Time Ago
  justNow: 'ahora mismo',
  yearsAgo: 'hace {count} año | hace {count} años',
  monthsAgo: 'hace {count} mes | hace {count} meses',
  daysAgo: 'hace {count} día | hace {count} días',
  hoursAgo: 'hace {count} hora | hace {count} horas',
  minutesAgo: 'hace {count} minuto | hace {count} minutos',
  secondsAgo: 'hace {count} segundo | hace {count} segundos',

  // Driver.js Intro Tour
  introCurrentModelTitle: 'Modelo Actual',
  introCurrentModelDesc: 'Selecciona qué Modelo Personalizado usar para trabajar con el Reporte del Modelo y el Simulador en Línea.',
  introModelReportTitle: 'Reporte del Modelo',
  introModelReportDesc: 'Visualiza un reporte que muestra el Gasto en Marketing estimado y KPI para el Modelo Actual. Este reporte se calcula basándose en el Modelo de Referencia especificado en la creación del modelo.',
  introMediaPlannerTitle: 'Planificador de Medios',
  introMediaPlannerDesc: 'Ejecuta Simulaciones y Optimizaciones. Visualiza KPI Simulado y KPI Optimizado para el: Período, Presupuesto, Restricciones de Medios/Puntos de Contacto y Prioridades de Segmento especificados.',
  introModelManagerTitle: 'Gestor de Modelos',
  introModelManagerDesc: 'Crea Modelos Personalizados basados en cualquiera de los Modelos de Referencia disponibles y en datos específicos del cliente utilizados para ajustarlos.',
  introModelDeletedTitle: 'Modelo Eliminado',
  introModelDeletedDesc: 'El modelo que tenías seleccionado acaba de ser eliminado. Por favor selecciona otro.',

  // Footer Copyright
  poweredBy: 'Desarrollado por ',
  allRightsReserved: 'Todos los derechos reservados - '
}
